<template>
  <div class="main-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="home-log">
          <img src="@/assets/img/home-edu.png" />
        </span>
        <span class="bread" @click="back">预约管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <span class="main-color">预约详情</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div style="margin-top:10px">
      <el-card shadow="never">
        <el-table :data="tableData" border :header-cell-style="$method.titleClass" style="margin-top:10px">
          <el-table-column type="index" align="center" width="75" label="序号" ></el-table-column>
          <el-table-column prop="realname" align="center" label="姓名"></el-table-column>
          <el-table-column prop="phone" align="center" label="手机号"></el-table-column>
          <el-table-column prop="national_id" align="center" label="身份证" :formatter="preengageNumberShow"></el-table-column>
          <el-table-column prop="internet_reg_no" align="center" label="网络报名号"></el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      id:0,
    };
  },
  mounted() {
    this.id = this.$route.params.id
      this.getInfo()
  },
  methods: {
    getInfo() {
      this.$request.getNF(this.$url.type.base, this.$url.edu.projectDetail, {id:this.id}, response => {
        this.tableData = [];
        this.tableData = response.data
      });
    },
    back() {
      this.$router.push("/eduHome/projectList");
    }
  }
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 10px;
}
</style>
